export default __webpack_public_path__ + "static/media/makiz.ac7d8025.png";